module.exports = __webpack_public_path__ + "static/img/Michael-Walters.f47de75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Michael-Walters.jpg
// module id = 4Yu/
// module chunks = 0